<tc-documents-search-results
        [colDefConfig]="colDefConfig">
</tc-documents-search-results>
